import { type FC, useEffect, useState } from 'react';
import { CircularProgress } from '@material-ui/core';
import cx from 'classnames';

import styles from './SuspenseFallback.module.css';

const DEFAULT_DELAY = 300;

interface Props {
  className?: string;
  delay?: number;
}

export const SuspenseFallback: FC<Props> = ({ className, delay = DEFAULT_DELAY }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!delay) {
      return;
    }

    setVisible(false);
    const timer = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  if (!visible) {
    return null;
  }

  return (
    <div className={cx(styles.root, className)}>
      <CircularProgress />
    </div>
  );
};

SuspenseFallback.displayName = 'SuspenseFallback';
